import React, { useState, useEffect } from 'react';
import SvgIcon from "../../utils/Icon";
import { ReactComponent as Aliado } from "../../assets/icons/aliado.svg";
import apiClient from '../../utils/axiosPetition';
import { alertaGeneral } from '../../utils/alertas';
import AliadoFicha from './AliadoFicha';
import { dedupeAliados } from './aliadosContenido';

const Aliados = () => {
  const [aliados, setAliados] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAliados();
  }, []);

  // Función para obtener aliados para doctores
  const getAliadosParaDoctores = async () => {
    try {
      // Obtener token del localStorage
      const token = localStorage.getItem('token');
      
      if (!token) {
        console.error('No hay token de autenticación');
        return { success: false, message: 'Token requerido' };
      }

      const baseURL = process.env.REACT_APP_BACKEND_URL || '';
      const response = await fetch(`${baseURL}/api/aliados/doctors`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      
      if (data.success) {
        console.log('Nivel de acceso:', data.accessLevel);
        console.log('Aliados:', data.data);
        return data;
      } else {
        console.error('Error:', data.message);
        return data;
      }
    } catch (error) {
      console.error('Error de red:', error);
      return { success: false, error: error.message };
    }
  };

  const fetchAliados = async () => {
    setLoading(true);
    try {
      // Verificar si hay token antes de intentar obtener aliados
      const token = localStorage.getItem('token');
      
      if (!token) {
        // Si no hay token, el usuario no está logueado, tratar como free
        // Obtener aliados públicos (sin autenticación)
        try {
          const res = await apiClient.get('/api/aliados');
          const aliadosActivos = Array.isArray(res.data.data)
            ? res.data.data.filter(aliado => 
                aliado.estado === 'activo' && 
                aliado.visible !== false
              )
            : [];
          setAliados(dedupeAliados(aliadosActivos));
        } catch (publicErr) {
          console.error('Error al cargar aliados públicos:', publicErr);
          setAliados([]);
        }
        return;
      }
      
      // Si hay token, intentar con el endpoint para doctores
      const doctorData = await getAliadosParaDoctores();
      
      if (doctorData.success) {
        setAliados(dedupeAliados(doctorData.data || []));
      } else {
        // Fallback al endpoint original si el nuevo falla
        console.log('Usando fallback al endpoint original');
        try {
          const res = await apiClient.get('/api/aliados');
          const aliadosActivos = Array.isArray(res.data.data)
            ? res.data.data.filter(aliado => 
                aliado.estado === 'activo' && 
                aliado.visible !== false
              )
            : [];
          setAliados(dedupeAliados(aliadosActivos));
        } catch (fallbackErr) {
          console.error('Error en fallback:', fallbackErr);
          setAliados([]);
        }
      }
    } catch (err) {
      console.error('Error al cargar aliados:', err);
      alertaGeneral({
        titulo: 'Error',
        messageHtml: 'Error al cargar los aliados.',
        isError: true
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="mx-4">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-800 flex items-center">
            <div className="bg-gradient-to-r from-[#f79865ff] to-[#ffaa6b] p-3 rounded-xl mr-4 shadow-md">
              <SvgIcon Icon={Aliado} className={"w-6 h-6 text-white"} />
            </div>
            Aliados estratégicos
          </h2>
        </div>
        <div className="bg-white rounded-2xl shadow-md p-8 border border-gray-200">
          <div className="text-center text-gray-600 py-10">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[#f79865ff] mb-4"></div>
            <p>Cargando aliados...</p>
          </div>
        </div>
      </div>
    );
  }

  if (aliados.length === 0) {
    return (
      <div className="mx-4">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-800 flex items-center">
            <div className="bg-gradient-to-r from-[#f79865ff] to-[#ffaa6b] p-3 rounded-xl mr-4 shadow-md">
              <SvgIcon Icon={Aliado} className={"w-6 h-6 text-white"} />
            </div>
            Aliados estratégicos
          </h2>
        </div>
        <div className="bg-white rounded-2xl shadow-md p-8 border border-gray-200">
          <div className="text-center text-gray-500 py-10">
            <SvgIcon Icon={Aliado} className={"w-16 h-16 mx-auto mb-4 text-gray-300"} />
            <p className="text-lg">No hay aliados disponibles en este momento.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-4">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center">
          <div className="bg-gradient-to-r from-[#f79865ff] to-[#ffaa6b] p-3 rounded-xl mr-4 shadow-md">
            <SvgIcon Icon={Aliado} className={"w-6 h-6 text-white"} />
          </div>
            Aliados estratégicos
        </h2>
      </div>
      <div id="aliados-estrategicos" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {aliados.map((aliado, index) => (
          <AliadoFicha key={aliado._id || aliado.id || index} aliado={aliado} />
        ))}
      </div>
    </div>
  );
}

export default Aliados;
